// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__6uFYP","messages":"Chat_messages__2vfx3","dateDivider":"Chat_dateDivider__1FqcK"};